import React from "react";

const DownloadPDFButton = ({ propiedadId }) => {
    const handleDownload = () => {
        const url = `${window.REACT_APP_API_ENDPOINT}/api/pdf/informe-pdf/${propiedadId}`;
        window.open(url, "_blank");
    };

    return (
        <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded shadow"
        >
            📄 Descargar informe PDF
        </button>
    );
};

export default DownloadPDFButton;
